import { request } from "../../../../../apis";

export const apiGetChatContent = (params: any): any =>
  request("get", `/api/user/order/message/${params.transId}`, null, true);

export const apiSendChat = (params: any) =>
  request("post", `/api/user/order/message`, params, true, true);
